import {
  AccessResource,
  GeneralAccessResource,
  VendorAccessResource,
  AccessResourceAdNetworks,
  AccessResourceAgencyTaggedData,
  AccessResourceRevenueData,
  AccessResourceLocation,
  AccessRoleResource,
} from '../../../../shared/types';

export type AccessResourcePermissions = Record<AccessResource, AccessRoleResource>;

export type Permissions = Record<AccessResource, number>;

export type AccessControlReducer = {
  loadingStatus: number;
  userPermissionsLoadingStatus: number;
  defaultRolesLoadingStatus: number;
  error: Record<string, any>;
  data?: AccessResourcePermissions;
  defaultRoles?: {
    [id: string]: Permissions;
  } | null;
  appDefaultRoles: AccessResourcePermissions | null | undefined;
};

export type Location = AccessResourceLocation;

export type AdNetworks = AccessResourceAdNetworks;

export type RevenueData = AccessResourceRevenueData;

export type AgencyTaggedData = AccessResourceAgencyTaggedData;

export { AccessResource, VendorAccessResource };

export type Filters = {
  ad_networks?: string[];
  location?: string[];
};

export type FilterToggles = Record<VendorAccessResource, boolean>;

export type UiRoleId = 1 | 2 | 3 | 4 | 5 | 10 | 101 | 102 | 200;

export type UserData = {
  name: string;
  last_name: string;
  email: string;
  uiRoleId: string; // we stringify the UiRoleId before sending to backend
  permissions: Permissions;
};

export type AgencyRelationshipData = {
  agency_id: string;
  label?: string;
  uiRoleId: string;
  permissions?: Permissions;
};

export type TeamRoleType =
  | 'ADMIN'
  | 'TEAM_MEMBER'
  | 'FULL_READ'
  | 'LIMITED_READ'
  | 'USER_COORDINATOR'
  | 'CUSTOM'
  | 'NO_ACCESS';

export type AgencyTeamRoleType = 'ADMIN' | 'TEAM_MEMBER';

export type AccessRoleDropdownOption = {
  name: string;
  label: string;
  value: UiRoleId | string;
  description?: string;
};

export type RoleOptionMapping = Record<TeamRoleType, AccessRoleDropdownOption>;

export type UiRoleMapping<T extends string> = Record<T, UiRoleId>;

export type AccessFeatureFilters = {
  [K in GeneralAccessResource]?: string[];
};
